import { render } from "./StepFormFinal.vue?vue&type=template&id=6f0732ec&scoped=true"
import script from "./StepFormFinal.vue?vue&type=script&lang=js"
export * from "./StepFormFinal.vue?vue&type=script&lang=js"

import "./StepFormFinal.vue?vue&type=style&index=0&id=6f0732ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0732ec"]])

export default __exports__